
import { useState } from 'react';

const AdminSettings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [notifications, setNotifications] = useState({
    newApplication: true,
    newMessage: true,
    demoRequest: true,
    emailNotifications: true,
    smsNotifications: false
  });

  const [profileData, setProfileData] = useState({
    name: 'Admin',
    email: 'admin@webcoll.com',
    phone: '0545 148 59 52',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const tabs = [
    { id: 'profile', label: 'Profil Bilgileri', icon: 'ri-user-settings-line' },
    { id: 'notifications', label: 'Bildirim Tercihleri', icon: 'ri-notification-3-line' },
    { id: 'theme', label: 'Tema Seçimi', icon: 'ri-palette-line' },
    { id: 'security', label: 'Güvenlik', icon: 'ri-shield-check-line' }
  ];

  const handleProfileUpdate = (e: React.FormEvent) => {
    e.preventDefault();
    // Profil güncelleme işlemi
    alert('Profil bilgileri güncellendi!');
  };

  const handlePasswordChange = (e: React.FormEvent) => {
    e.preventDefault();
    if (profileData.newPassword !== profileData.confirmPassword) {
      alert('Yeni şifreler eşleşmiyor!');
      return;
    }
    // Şifre değiştirme işlemi
    alert('Şifre başarıyla değiştirildi!');
    setProfileData(prev => ({
      ...prev,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }));
  };

  const handleNotificationChange = (key: string, value: boolean) => {
    setNotifications(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Panel Ayarları</h1>
        <p className="text-gray-600">Yönetim paneli ayarlarınızı buradan düzenleyebilirsiniz</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar Tabs */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-2xl p-4 shadow-lg border border-gray-100">
            <nav className="space-y-2">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`w-full flex items-center px-4 py-3 text-left rounded-xl transition-all duration-200 ${
                    activeTab === tab.id
                      ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <i className={`${tab.icon} text-lg mr-3`}></i>
                  <span className="font-medium">{tab.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Content Area */}
        <div className="lg:col-span-3">
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
            {/* Profile Tab */}
            {activeTab === 'profile' && (
              <div className="space-y-8">
                <div>
                  <h2 className="text-xl font-bold text-gray-900 mb-4">Profil Bilgileri</h2>
                  
                  <form onSubmit={handleProfileUpdate} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Ad Soyad</label>
                        <input
                          type="text"
                          value={profileData.name}
                          onChange={(e) => setProfileData(prev => ({ ...prev, name: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">E-posta</label>
                        <input
                          type="email"
                          value={profileData.email}
                          onChange={(e) => setProfileData(prev => ({ ...prev, email: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
                        <input
                          type="tel"
                          value={profileData.phone}
                          onChange={(e) => setProfileData(prev => ({ ...prev, phone: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    </div>
                    
                    <button
                      type="submit"
                      className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl hover:from-blue-600 hover:to-purple-700 transition-all duration-300 whitespace-nowrap"
                    >
                      <i className="ri-save-line mr-2"></i>
                      Profili Güncelle
                    </button>
                  </form>
                </div>

                <hr className="border-gray-200" />

                {/* Password Change */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Şifre Değiştir</h3>
                  
                  <form onSubmit={handlePasswordChange} className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Mevcut Şifre</label>
                      <input
                        type="password"
                        value={profileData.currentPassword}
                        onChange={(e) => setProfileData(prev => ({ ...prev, currentPassword: e.target.value }))}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Yeni Şifre</label>
                        <input
                          type="password"
                          value={profileData.newPassword}
                          onChange={(e) => setProfileData(prev => ({ ...prev, newPassword: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Yeni Şifre (Tekrar)</label>
                        <input
                          type="password"
                          value={profileData.confirmPassword}
                          onChange={(e) => setProfileData(prev => ({ ...prev, confirmPassword: e.target.value }))}
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                      </div>
                    </div>
                    
                    <button
                      type="submit"
                      className="px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors whitespace-nowrap"
                    >
                      <i className="ri-lock-line mr-2"></i>
                      Şifreyi Değiştir
                    </button>
                  </form>
                </div>
              </div>
            )}

            {/* Notifications Tab */}
            {activeTab === 'notifications' && (
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-6">Bildirim Tercihleri</h2>
                
                <div className="space-y-6">
                  <div className="bg-gray-50 rounded-xl p-4">
                    <h3 className="font-semibold text-gray-900 mb-4">Panel Bildirimleri</h3>
                    <div className="space-y-4">
                      {[
                        { key: 'newApplication', label: 'Yeni başvuru geldiğinde bildir', description: 'Yeni form başvuruları için anlık bildirim' },
                        { key: 'newMessage', label: 'Yeni mesaj geldiğinde bildir', description: 'İletişim formundan gelen mesajlar için bildirim' },
                        { key: 'demoRequest', label: 'Demo talebi geldiğinde bildir', description: 'Demo talep formları için bildirim' }
                      ].map((item) => (
                        <div key={item.key} className="flex items-center justify-between p-3 bg-white rounded-lg">
                          <div>
                            <p className="font-medium text-gray-900">{item.label}</p>
                            <p className="text-sm text-gray-600">{item.description}</p>
                          </div>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              checked={notifications[item.key as keyof typeof notifications]}
                              onChange={(e) => handleNotificationChange(item.key, e.target.checked)}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-xl p-4">
                    <h3 className="font-semibold text-gray-900 mb-4">E-posta ve SMS Bildirimleri</h3>
                    <div className="space-y-4">
                      {[
                        { key: 'emailNotifications', label: 'E-posta bildirimleri', description: 'Önemli güncellemeler için e-posta gönder' },
                        { key: 'smsNotifications', label: 'SMS bildirimleri', description: 'Acil durumlar için SMS gönder' }
                      ].map((item) => (
                        <div key={item.key} className="flex items-center justify-between p-3 bg-white rounded-lg">
                          <div>
                            <p className="font-medium text-gray-900">{item.label}</p>
                            <p className="text-sm text-gray-600">{item.description}</p>
                          </div>
                          <label className="relative inline-flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              checked={notifications[item.key as keyof typeof notifications]}
                              onChange={(e) => handleNotificationChange(item.key, e.target.checked)}
                              className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Theme Tab */}
            {activeTab === 'theme' && (
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-6">Tema Seçimi</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div
                    className={`p-6 rounded-2xl border-2 cursor-pointer transition-all duration-300 ${
                      !isDarkMode ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-white hover:border-gray-400'
                    }`}
                    onClick={() => setIsDarkMode(false)}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900">Açık Tema</h3>
                      <div className={`w-6 h-6 rounded-full border-2 ${!isDarkMode ? 'border-blue-500 bg-blue-500' : 'border-gray-300'}`}>
                        {!isDarkMode && <i className="ri-check-line text-white text-sm"></i>}
                      </div>
                    </div>
                    <div className="bg-white rounded-lg p-4 shadow-sm">
                      <div className="h-2 bg-gray-200 rounded mb-2"></div>
                      <div className="h-2 bg-gray-100 rounded mb-2 w-3/4"></div>
                      <div className="h-2 bg-gray-100 rounded w-1/2"></div>
                    </div>
                  </div>

                  <div
                    className={`p-6 rounded-2xl border-2 cursor-pointer transition-all duration-300 ${
                      isDarkMode ? 'border-blue-500 bg-blue-50' : 'border-gray-300 bg-white hover:border-gray-400'
                    }`}
                    onClick={() => setIsDarkMode(true)}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-gray-900">Koyu Tema</h3>
                      <div className={`w-6 h-6 rounded-full border-2 ${isDarkMode ? 'border-blue-500 bg-blue-500' : 'border-gray-300'}`}>
                        {isDarkMode && <i className="ri-check-line text-white text-sm"></i>}
                      </div>
                    </div>
                    <div className="bg-gray-800 rounded-lg p-4 shadow-sm">
                      <div className="h-2 bg-gray-600 rounded mb-2"></div>
                      <div className="h-2 bg-gray-700 rounded mb-2 w-3/4"></div>
                      <div className="h-2 bg-gray-700 rounded w-1/2"></div>
                    </div>
                  </div>
                </div>

                <div className="mt-6 p-4 bg-blue-50 rounded-xl">
                  <div className="flex items-start space-x-3">
                    <i className="ri-information-line text-blue-600 text-xl mt-0.5"></i>
                    <div>
                      <h4 className="font-medium text-blue-900">Tema Bilgisi</h4>
                      <p className="text-blue-700 text-sm mt-1">
                        Seçtiğiniz tema tercihi tarayıcınızda kaydedilir ve bir sonraki girişinizde hatırlanır.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Security Tab */}
            {activeTab === 'security' && (
              <div>
                <h2 className="text-xl font-bold text-gray-900 mb-6">Güvenlik Ayarları</h2>
                
                <div className="space-y-6">
                  {/* Two Factor Authentication */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <h3 className="font-semibold text-gray-900">İki Faktörlü Doğrulama (2FA)</h3>
                        <p className="text-sm text-gray-600 mt-1">Hesabınızı ekstra güvenlik katmanı ile koruyun</p>
                      </div>
                      <button className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors whitespace-nowrap">
                        <i className="ri-shield-check-line mr-2"></i>
                        Etkinleştir
                      </button>
                    </div>
                    <div className="bg-white rounded-lg p-4">
                      <div className="flex items-center space-x-3">
                        <i className="ri-smartphone-line text-2xl text-gray-400"></i>
                        <div>
                          <p className="font-medium text-gray-900">Authenticator Uygulaması</p>
                          <p className="text-sm text-gray-600">Google Authenticator veya benzeri uygulama kullanın</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* IP Restrictions */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">IP Adresi Sınırlaması</h3>
                    <p className="text-sm text-gray-600 mb-4">Sadece belirli IP adreslerinden giriş yapılmasına izin verin</p>
                    
                    <div className="space-y-3">
                      <div className="bg-white rounded-lg p-4">
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-medium text-gray-900">Mevcut IP: 192.168.1.100</p>
                            <p className="text-sm text-gray-600">Son giriş: Bugün 14:30</p>
                          </div>
                          <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">Aktif</span>
                        </div>
                      </div>
                      
                      <button className="w-full px-4 py-3 border-2 border-dashed border-gray-300 text-gray-600 rounded-lg hover:border-gray-400 hover:text-gray-700 transition-colors">
                        <i className="ri-add-line mr-2"></i>
                        Yeni IP Adresi Ekle
                      </button>
                    </div>
                  </div>

                  {/* Login History */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Giriş Geçmişi</h3>
                    <div className="space-y-3">
                      {[
                        { date: '8 Ocak 2025, 14:30', ip: '192.168.1.100', device: 'Chrome - Windows', status: 'success' },
                        { date: '8 Ocak 2025, 09:15', ip: '192.168.1.100', device: 'Chrome - Windows', status: 'success' },
                        { date: '7 Ocak 2025, 16:45', ip: '192.168.1.100', device: 'Safari - macOS', status: 'success' },
                        { date: '7 Ocak 2025, 11:20', ip: '10.0.0.50', device: 'Chrome - Windows', status: 'failed' }
                      ].map((login, index) => (
                        <div key={index} className="bg-white rounded-lg p-4">
                          <div className="flex items-center justify-between">
                            <div>
                              <p className="font-medium text-gray-900">{login.date}</p>
                              <p className="text-sm text-gray-600">{login.ip} • {login.device}</p>
                            </div>
                            <span className={`px-3 py-1 rounded-full text-sm ${
                              login.status === 'success' 
                                ? 'bg-green-100 text-green-800' 
                                : 'bg-red-100 text-red-800'
                            }`}>
                              {login.status === 'success' ? 'Başarılı' : 'Başarısız'}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Session Management */}
                  <div className="bg-gray-50 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <h3 className="font-semibold text-gray-900">Aktif Oturumlar</h3>
                        <p className="text-sm text-gray-600 mt-1">Tüm cihazlardaki aktif oturumlarınızı yönetin</p>
                      </div>
                      <button className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap">
                        <i className="ri-logout-box-line mr-2"></i>
                        Tüm Oturumları Sonlandır
                      </button>
                    </div>
                    
                    <div className="bg-white rounded-lg p-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-medium text-gray-900">Bu Cihaz</p>
                          <p className="text-sm text-gray-600">Chrome - Windows • 192.168.1.100</p>
                        </div>
                        <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Mevcut</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
